import { Typography, Button, Row, Col, Select, Tooltip, Card, Input, notification, Space, Tag, Spin } from 'antd';
import React, { useState } from 'react';
import { useCompanies, useListingCompanies } from '../../hooks/useCompanies';
import './modelList.scss';
import {
    fetchBaseFacePresignedUrl,
    useAddOccasion,
    useAssignToClient,
    useFetchModelById,
    useMakePublic,
    useRemoveFromClient,
    useRemoveOccasion,
} from '../../hooks/useSkuModal';
import { DeleteOutlined } from '@ant-design/icons';
import axios from 'axios';
import SkeletonImage from '../../commonComponents/ImageSkeleton';
import useLogout from '../../hooks/useLogout';
const { Text } = Typography;
const ModelOccasions = ({ isPublic, modelId, closeModal }) => {
    const [newOccasionDetails, setNewOccasionDetails] = useState({
        modelId,
        occasion: {},
    });
    const [assignToClientObj, setAssignToClientObj] = useState({ modelId });
    const [imageUploadLoading, setImageUploadLoading] = useState(false);
    const { data: companiesList } = useListingCompanies();
    const [api, contextHolder] = notification.useNotification();
    const { data: model, refetch: refetchModelById } = useFetchModelById(modelId);
    const onSuccess = () => {
        refetchModelById(modelId);
    };
    const { mutate: AddOccasion } = useAddOccasion(onSuccess);
    const { mutate: RemoveOccasion, isLoading: isRemoveOccasionLoading } = useRemoveOccasion(onSuccess);
    const { mutate: AssignToClient } = useAssignToClient(closeModal);
    const { mutate: MakePublic } = useMakePublic(closeModal);
    const { mutate: RemoveFromClient } = useRemoveFromClient();
    const { logout } = useLogout();

    const handleOccasionImageUpload = async e => {
        setImageUploadLoading(true);
        let uploadedFile = e.target.files[0];

        await fetchBaseFacePresignedUrl(uploadedFile, model.name, newOccasionDetails.occasion.name).then(async resp => {
            const url = resp.data.url;
            await axios
                .put(`${url}`, uploadedFile)
                .then(res => {
                    handleOccasionDetails({ key: resp.data.key }, 'image');
                    api.success({
                        message: 'Great!',
                        description: 'Image has been successfully uploaded!',
                        placement: 'topRight',
                    });
                    setImageUploadLoading(false);
                })
                .catch(err => {
                    api.warning({
                        message: 'Ooops!',
                        description: 'Image could not be uploaded!',
                        placement: 'topRight',
                    });
                    setImageUploadLoading(false);
                    if (err?.response?.status === 401) logout();
                });
        });
    };

    const handleOccasionDetails = (value, key) => {
        const occasionDetails = { ...newOccasionDetails };
        if (value) occasionDetails.occasion[key] = value;
        else delete occasionDetails.occasion[key];
        setNewOccasionDetails({ ...occasionDetails });
    };

    const handleRemoveOccasion = occasionId => {
        RemoveOccasion({ occasionId, modelId });
    };
    const handleCompanyId = companyId => {
        let tempAssignToClientObj = { ...assignToClientObj };
        tempAssignToClientObj.companyId = companyId;
        setAssignToClientObj({ ...tempAssignToClientObj });
    };
    const handleAssignToClient = () => {
        AssignToClient(assignToClientObj);
    };
    const handleRemoveFromClient = companyId => {
        RemoveFromClient({ modelId, companyId });
    };

    return (
        <div>
            {contextHolder}
            <Row>
                <Col span={7}>
                    <img src={model?.baseFace?.thumbPath?.url} />
                </Col>
                <Col span={17}>
                    <Row>
                        <Card
                            style={{
                                width: '100%',
                                marginBottom: '5px',
                                padding: 0,
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    padding: 0,
                                }}
                            ></div>
                            <Row>
                                <Text
                                    strong
                                    style={{
                                        marginBottom: '5px',
                                    }}
                                >
                                    Occasion Name *
                                </Text>
                                <Input
                                    placeholder="Enter the image label"
                                    onChange={e => handleOccasionDetails(e.target.value.trim(), 'name')}
                                    style={{
                                        marginBottom: '5px',
                                    }}
                                />
                            </Row>

                            <Row className="occasion_btns">
                                <label className="custom-file-upload">
                                    <input
                                        type="file"
                                        onChange={e => handleOccasionImageUpload(e)}
                                        disabled={!newOccasionDetails.occasion.name}
                                        accept=".png,.jpg,.jpeg"
                                        //   ref={ocassionRef}
                                    />
                                </label>

                                {imageUploadLoading && <Spin size="small" style={{ margin: 0 }} />}

                                <Button
                                    disabled={!newOccasionDetails.occasion.name || !newOccasionDetails.occasion.image}
                                    onClick={() => {
                                        AddOccasion(newOccasionDetails);
                                    }}
                                >
                                    Add Occasion
                                </Button>
                            </Row>
                        </Card>
                        <Card
                            style={{
                                width: '100%',
                                marginBottom: '5px',
                                padding: 0,
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    padding: 0,
                                }}
                            ></div>
                            <Row>
                                <Text
                                    strong
                                    style={{
                                        margin: '0px 10px 10px 10px',
                                    }}
                                >
                                    Assign to Client :
                                </Text>
                                <Select
                                    placeholder="Select a company"
                                    style={{ width: '200px', marginRight: '10px' }}
                                    onChange={id => handleCompanyId(id)}
                                >
                                    {companiesList &&
                                        companiesList.map(company => (
                                            <Select.Option key={company._id} value={company._id}>
                                                {company.name}
                                            </Select.Option>
                                        ))}
                                </Select>
                                <Button disabled={!assignToClientObj.companyId} onClick={handleAssignToClient}>
                                    Assign
                                </Button>
                            </Row>
                            {!isPublic && (
                                <>
                                    <Row className="clients_row">
                                        <Space size={[0, 8]} wrap>
                                            {model?.privateToClients.map(client => (
                                                <Tag key={client._id} id={client._id} closable onClose={() => handleRemoveFromClient(client._id)}>
                                                    {client.name}
                                                </Tag>
                                            ))}
                                        </Space>
                                    </Row>
                                    <div>
                                        <Button size="small" shape="round" onClick={() => MakePublic({ modelId })}>
                                            {' '}
                                            Make Public
                                        </Button>
                                    </div>
                                </>
                            )}
                        </Card>
                    </Row>
                </Col>
            </Row>
            <Row>
                <div className="occasions_wrapper">
                    {model?.occasions.map(occasion => (
                        <div className="occasion_img_container" key={occasion._id}>
                            {/* <img
                src={occasion.image.thumbPath.url}
                className="occasion_img"
              /> */}
                            <SkeletonImage src={occasion.image.thumbPath.url} className="occasion_img" />
                            <Text className="label onImage_position">{occasion.name}</Text>
                            <Tooltip title={(model?.occasions?.length > 1 && 'Delete Occasion?') || ''} color={'#77788582'}>
                                <Text className="remove onImage_position">
                                    <DeleteOutlined
                                        onClick={() => model?.occasions?.length > 1 && handleRemoveOccasion(occasion._id)}
                                        disabled={isRemoveOccasionLoading || model?.occasions?.length <= 1}
                                    />
                                </Text>
                            </Tooltip>
                        </div>
                    ))}
                </div>
            </Row>
        </div>
    );
};

export default ModelOccasions;
